module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "restaurant-menu-calendar"
    }
  }, [_c('div', {
    staticClass: "restaurant-calendar",
    attrs: {
      "id": "calendar"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ed0d44a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/shared/RestaurantCalendar.vue
// module id = 1474
// module chunks = 6